import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppInitService } from './core/services/app-init.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, CommonModule]
})
export class AppComponent implements OnInit {
  public title = 'WAPI Frontend';
  private appInitService = inject(AppInitService);

  async ngOnInit(): Promise<void> {
    await this.appInitService.initializeApp();
  }
}
